import { Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { generateFCMToken } from '../firbase';

function RequestNotificationPermission() {
    const [dialogStatus,setDialogStatus] = useState(false);
    
    const handleNo = () =>{
        setDialogStatus(false);
    }

    const handleYes = async () =>{
        const permission = await Notification.requestPermission();
        if(permission == "granted"){
            generateFCMToken();
            setDialogStatus(false);
        }
    }


    useEffect(()=>{
        console.log(Notification.permission)
        if(Notification.permission === "default"){
            setDialogStatus(true);
        }
        if(Notification.permission === "granted"){
            generateFCMToken()
        }
    },[])
    
    return (
        <Dialog
            open={dialogStatus}
            keepMounted
           
            maxWidth="sm"
            fullWidth={true}
        >
            <DialogTitle>Would You like to receive notifications</DialogTitle>
            <DialogContent>
                <p>Get Latest update about your complaints progress</p>
            </DialogContent>
            <DialogActions>
                <button className='btn btn-outline-default' onClick={handleNo}  >No</button>
                <button className='btn btn-primary' onClick={handleYes} >Yes, Allow</button>
                
            </DialogActions>
        </Dialog>
    )
}

export default RequestNotificationPermission